import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import {
  useLocalStorage,
  useLocalStorageWithTimeout,
  useJwtStorage,
} from "../../hooks/useLocalStorage";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import { getPeriodName } from "../../services/SchoolService";

import List from "@mui/material/List";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Alert from "@mui/material/Alert";
import dayjs from "dayjs";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { ReactComponent as ExpandMoreIcon } from "../../icons/ExpandMore24.svg";

import { useNavigate } from "react-router-dom";

import { getYYYYMMDD } from "../../services/DateService";
import { formatHourMinute } from "../../services/StringService";

import MessageLists from "../../components/MessageLists";
import DrawerAppBar from "../../components/DrawerAppBar";
import StudentSelectPeriods from "../../components/student/StudentSelectPeriods";
import StudentCourseGrid from "../../components/student/StudentCourseGrid";
import Button from "@mui/material/Button";
import PeriodListItem from "../../components/PeriodListItem";

import { getDayForStudent } from "../../services/ActivityService";
import { getStudentMeetings } from "../../services/MeetingService";
import { hasError, getError } from "../../services/ServiceHelper";
import { getStudentEvents } from "../../services/EventService";

import {
  showToast,
  showOKCancelDialog,
  showOptions,
} from "../../components/ATPDialogs";
import SubTitle from "../../components/SubTitle";
import {
  getEventStartTime,
  getEventEndTime,
} from "../../services/EventService";
import {
  StripedTableRow,
  StripedTableCell,
} from "../../components/StripedTable";

import {
  isEventEnabled,
  isMeetingEnabled,
  isCourseEnabled,
  isActivitiesEnabled,
  isCommunityServiceEnabled,
  getSchoolTeachers,
} from "../../services/SchoolService";
import TableRowNoResults from "../../components/TableRowNoResults";
import { getUserDashboard } from "../../services/ReportService";
import Title from "../../components/Title";
import HeaderText from "../../components/HeaderText";
import AtpCarousel from "../../components/AtpCarousel";
import {
  showError,
  showSuccess,
  showSuccessHtml,
} from "../../components/ATPDialogs";
import { doSingleSignup } from "../../services/ActivityService";
import { doService } from "../../services/ServiceHelper";
import { doTardyQrScore } from "../../services/ScoreService";

const StudentWelcome = () => {
  const DAYS_MINUTES_2 = 2880;

  const [_jwt] = useJwtStorage();
  const [_school] = useLocalStorage("Auth", "school", null);

  const [_messages, setMessages] = useLocalStorage(
    "StudentWelcome",
    "messages",
    [],
  );

  const [_tomorrowDialogOpen, setTomorrowDialogOpen] = useState(false);
  const [_tomorrowPeriods, setTomorrowPeriods] = useState([]);

  const [_alerts, setAlerts] = React.useState([]);
  const [_infos, setInfos] = React.useState([]);
  const [_warnings, setWarnings] = React.useState([]);
  const [_consequences, setConsequences] = React.useState([]);
  const [_recommendations, setRecommendations] = React.useState([]);
  const [_meetings, setMeetings] = useState([]);
  const [_events, setEvents] = useState([]);
  const [_spotlightActivities, setSpotlightActivities] = useState([]);

  const [_tabsToShow, setTabsToShow] = React.useState([]);
  const [_carouselItems, setCarouselItems] = React.useState([]);
  const [_allTeachers, setAllTeachers] = useLocalStorageWithTimeout(
    "User",
    "allTeachers",
    null,
    DAYS_MINUTES_2,
  );

  const navigate = useNavigate();
  const [_dashboardTitle, setDashboardTitle] = useState("Student Home");

  useEffect(() => {
    initTabs();
    initContent();
  }, []);

  const initTabs = () => {
    const tabsToShow = [];
    if (isActivitiesEnabled(_school)) {
      tabsToShow.push("activitiesTab");
    }
    if (isMeetingEnabled(_school)) {
      tabsToShow.push("meetingsTab");
    }
    if (isEventEnabled(_school)) {
      tabsToShow.push("eventsTab");
    }
    if (isCourseEnabled(_school)) {
      tabsToShow.push("coursesTab");
    }
    setTabsToShow(tabsToShow);
  };

  const loadRecommendations = (data) => {
    setRecommendations(data);
  };

  const loadAnnouncements = (data) => {
    setAlerts(data.A);
    setInfos(data.I);
    setWarnings(data.W);

    if (data.dayType && (_school.subdomain === "mavtime" || _school.subdomain === "hhs")) {
      setDashboardTitle("Dashboard - " + data.dayType + " Day");
    }

  };

  const initDashData = () => {
    getUserDashboard(_school, _jwt)
      .then((result) => {
        if (result == null || result.data == null) {
          showToast("I", "Logged in. No Dashboard Data Found.");
          return;
        }

        setMessages(result.data.messages);
        loadAnnouncements(result.data.announcements);
        loadRecommendations(result.data.recommendations);
        setConsequences(result.data.consequences);

        const carouselItems = [];

        setSpotlightActivities(result.data.spotlights);
        for (const spotlight of result.data.spotlights) {
          const item = {
            title: "Activity:" + spotlight.activityName,
            eid: spotlight.adEid,
            detail1: `Where: ${spotlight.first_name} ${spotlight.last_name} at ${spotlight.locationName}`,
            detail2: `When: ${dayjs(spotlight.date).format("MM/DD")} at ${getPeriodName(_school, spotlight.period - 1)}`,
            detail3: "Note: " + spotlight.note,
            imageUrl: `/image/school/${_school.subdomain}/logo-small.png`,
          };

          for (const file of spotlight.activityFiles) {
            if (file.status === 100) {
              item.imageUrl = file.thumbnailCdnUrl;
              break;
            }
          }

          carouselItems.push(item);
        }
        setCarouselItems(carouselItems);
      })
      .catch((error) => {
        showToast("E", "Unable to get Dashboard Data.");
        console.log(error);
      });
  };

  const initContent = () => {
    initDashData();

    if (isMeetingEnabled(_school)) {
      initMeetings();
    }
    if (isEventEnabled(_school)) {
      initEvents();
    }
  };

  const initEvents = () => {
    const startDate = getYYYYMMDD();

    getStudentEvents(_school, _jwt, startDate, startDate)
      .then((result) => {
        console.log(result.data);
        setEvents(result.data.current_events);
      })
      .catch((error) => {
        console.log(error);
        showToast("E", "Unable to get Events.");
      })
      .finally(() => {});
  };

  const initMeetings = () => {
    const startDate = getYYYYMMDD();

    getStudentMeetings(_school, _jwt, startDate, startDate)
      .then((result) => {
        setMeetings(result.data);
      })
      .catch((error) => {
        console.log(error);
        showToast("E", "Unable to get Meetings.");
      })
      .finally(() => {});
  };

  const initAllTeachers = async () => {
    const result = await getSchoolTeachers(_school, _jwt);
    setAllTeachers(result.data);
    return result.data;
  };

  const onClickSignUp = () => {
    navigate("/student/signup");
  };

  const handleEvents = () => {
    navigate("/student/events");
  };

  const handleCourses = () => {
    navigate("/student/courses");
  };

  /**
   * keys: "period1", "period2", etc.
   * @param {*} activities
   */
  const loadTomorrow = (rawActivities) => {
    const activities = [];

    if (rawActivities == null) {
      for (let i = 1; i <= _school.maxActivityCount; i++) {
        activities.push({});
      }
      setTomorrowPeriods(activities);
      return;
    }

    for (let i = 1; i <= _school.maxActivityCount; i++) {
      const key = `period${i}`;

      let newActivity = {};
      if (rawActivities[key].length > 0) {
        newActivity = rawActivities[key][0];
      }

      activities.push(newActivity);
    }

    setTomorrowPeriods(activities);
  };

  const handleTomorrow = () => {
    const tomorrowDate = dayjs().add(1, "day").format("YYYY-MM-DD");

    loadTomorrow(null);
    getDayForStudent(_school, _jwt, tomorrowDate)
      .then((result) => {
        if (hasError(result.data) === true) {
          window.showSnack("Unable to get Tomorrow: " + getError(result.data));
        } else {
          const studentDayData = result.data;
          loadTomorrow(studentDayData.activities);
          setTomorrowDialogOpen(true);
        }
      })
      .catch((error) => {
        console.log(error);
        window.showSnack("Unable to get Tomorrow.");
      })
      .finally(() => {});
  };

  const handleFuture = () => {
    navigate("/student/activity/history");
  };

  const handleSuggest = () => {
    navigate("/student/suggest");
  };

  const handleTomorrowDialogClose = () => {
    setTomorrowDialogOpen(false);
  };

  const onClickCreatePass = () => {
    navigate("/student/pass/request");
  };

  const onClickAddService = () => {
    navigate("/student/service/add");
  };

  const handleActivitySignup = (ad) => {
    console.log(ad);
    // try to sign up
    doSingleSignup(_school, _jwt, ad.eid).then((results) => {
      if (results.detail != null) {
        showError("Unable to Add Activity", results.detail);
        return;
      }

      showSuccess("Activity Added!");
    });
  };

  const doCreateTardy = (teacherEid, tardyCategoryId) => {
    doService(
      doTardyQrScore(_school, _jwt, teacherEid, tardyCategoryId, null, "Tardy from Student"),
      (results) => {
        const student = results.data.student;
        const score = results.data.score;

        const html = `
          <table style="margin-left:auto;margin-right:auto">
            <tbody>
              <tr>
                <td style="font-weight:bold;text-align:right">Student:</td>
                <td style="text-align:left">${student.first_name} ${
                  student.last_name
                } (${student.grade})</td>
              </tr>
              <tr>
                <td style="font-weight:bold;text-align:right;font-size:20px">Created On:</td>
                <td style="text-align:left">${dayjs(score.dt).format(
                  "MM/DD/YY hh:mm a",
                )}</td>
              </tr>
              <tr>
                <td style="font-weight:bold;text-align:right">Score Type:</td>
                <td style="text-align:left">${score.category_name}</td>
              </tr>
              <tr>
                <td style="font-weight:bold;text-align:right">Consequence:</td>
                <td style="text-align:left">${score.consequence_name}</td>
              </tr>
            </tbody>
          </table>
          
        `;

        showSuccessHtml(`Tardy Record Created`, html);
        return;
      },
      (detail) => {
        showError("Unable to Use Tardy QR", detail);
        return;
      },
    );
  };

  const getTeacherOptions = (allTeachers) => {
    const map = {};
    for (let teacher of allTeachers) {
      map[teacher.eid] = `${teacher.last_name}, ${teacher.first_name}`;
    }
    return map;
  };

  const onClickMarkTardy = async () => {
    let allTeachers = _allTeachers;
    if (_allTeachers == null) {
      // alert('gettiung teachers')
      allTeachers = await initAllTeachers();
    }

    const teacherResult = await showOptions(
      `Select Your Current Teacher`,
      "Click Teacher Name",
      getTeacherOptions(allTeachers),
    );
    if (!teacherResult.isConfirmed) {
      return;
    }

    const teacherEid = teacherResult.value;
    const tardyCategoryId = _school.tardyCategoryId;

    console.log(_school);

    if (tardyCategoryId == null || tardyCategoryId === "") {
      showError(
        "Unable to Mark Tardy",
        "No Tardy Category is configured for this school.",
      );
      return;
    }

    showOKCancelDialog(
      "Create Tardy Record",
      "WARNING:  This will assign a tardy record to you. Click OK to continue.",
      () => {
        doCreateTardy(teacherEid, tardyCategoryId);
      },
      () => {
        return;
      },
    );
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text={_dashboardTitle} />

        <MessageLists
          alerts={_alerts}
          infos={_infos}
          warnings={_warnings}
          messages={_messages}
          consequences={_consequences}
          recommendations={_recommendations}
        />

        <Grid container spacing={2} sx={{ mt: 0, mb: 1 }}>
          {isActivitiesEnabled(_school) && (
            <>
              <Grid item xs={6}>
                <Button
                  key="signup"
                  onClick={onClickSignUp}
                  size="large"
                  variant="contained"
                  fullWidth
                >
                  SIGN UP
                </Button>
              </Grid>
            </>
          )}
          <Grid item xs={6}>
            <Button
              key="signup"
              onClick={onClickCreatePass}
              size="large"
              variant="contained"
              className="button1"
              fullWidth
            >
              Hall Pass
            </Button>
          </Grid>
          {_school.showTardyButton === "Y" && (
            <>
              <Grid item xs={6} />
              <Grid item xs={6}>
                <Button
                  key="signup"
                  onClick={onClickMarkTardy}
                  size="large"
                  variant="outlined"
                  fullWidth
                >
                  Mark Tardy
                </Button>
              </Grid>
            </>
          )}

          {isCommunityServiceEnabled(_school) === true && (
            <Grid item xs={6}>
              <Button
                key="signup"
                onClick={onClickAddService}
                size="large"
                variant="contained"
                className="button1"
                fullWidth
              >
                Add Service Op
              </Button>
            </Grid>
          )}
        </Grid>
        <br />

        {_tabsToShow.length > 0 && (
          <>
            {isActivitiesEnabled(_school) && (
              <Accordion
                defaultExpanded={_tabsToShow[0] === "activitiesTab"}
                disableGutters
                sx={{ mt: 1 }}
              >
                <AccordionSummary
                  className="accordionTitle"
                  expandIcon={<ExpandMoreIcon />}
                >
                  Activities
                </AccordionSummary>
                <AccordionDetails>
                  {_spotlightActivities.length > 0 && (
                    <>
                      <HeaderText
                        text={`Spotlight Activities (${_spotlightActivities.length}):`}
                      />
                      <AtpCarousel
                        items={_carouselItems}
                        onSignup={handleActivitySignup}
                      />
                    </>
                  )}
                  <HeaderText text="Today's Activities:" />
                  <StudentSelectPeriods
                    signupDate={dayjs().format("YYYY-MM-DD")}
                    sourceUrl="/student/welcome"
                  />
                  <br />

                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Button
                        variant="contained"
                        key="tmrw"
                        onClick={handleTomorrow}
                        size="large"
                        fullWidth
                      >
                        Tomorrow
                      </Button>
                    </Grid>
                    <Grid item xs={4}>
                      <Button
                        className="button1"
                        key="future"
                        onClick={handleFuture}
                        size="large"
                        fullWidth
                      >
                        History
                      </Button>
                    </Grid>
                    <Grid item xs={4}>
                      <Button
                        className="button2"
                        key="suggest"
                        onClick={handleSuggest}
                        size="large"
                        fullWidth
                      >
                        Suggest
                      </Button>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )}

            {isMeetingEnabled(_school) && (
              <Accordion
                defaultExpanded={_tabsToShow[0] === "meetingsTab"}
                disableGutters
                sx={{ mt: 1 }}
              >
                <AccordionSummary
                  className="accordionTitle"
                  expandIcon={<ExpandMoreIcon />}
                >
                  Meetings
                </AccordionSummary>
                <AccordionDetails>
                  <HeaderText text="Today's Meetings:" />
                  {_meetings.map((m) => (
                    <Alert
                      severity="info"
                      key={m.eid}
                      sx={{ mb: 0.5, pt: 0, pb: 0 }}
                    >
                      <b>
                        {formatHourMinute(m.startHour, m.startMinute)}:{" "}
                        {m.meetingTypeName} Meeting:
                      </b>
                      <br /> {m.title}
                    </Alert>
                  ))}
                  <TableRowNoResults
                    data={_meetings}
                    text="-- NO MEETINGS RETURNED --"
                  />
                </AccordionDetails>
              </Accordion>
            )}

            {isEventEnabled(_school) && (
              <Accordion
                defaultExpanded={_tabsToShow[0] === "eventsTab"}
                disableGutters
                sx={{ mt: 1 }}
              >
                <AccordionSummary
                  className="accordionTitle"
                  expandIcon={<ExpandMoreIcon />}
                >
                  Events
                </AccordionSummary>
                <AccordionDetails>
                  <HeaderText text="Today's Events:" />
                  <Paper elevation={3} sx={{ mt: 1, mb: 2 }}>
                    <Table>
                      <TableBody>
                        <TableRowNoResults
                          data={_events}
                          text="-- NO EVENTS RETURNED --"
                        />
                        {_events.map((evt) => (
                          <StripedTableRow key={evt.eid}>
                            <StripedTableCell width={150}>
                              {getEventStartTime(evt)} - {getEventEndTime(evt)}
                            </StripedTableCell>
                            <StripedTableCell>
                              <b>
                                {evt.eventTypeName}: {evt.title}-{" "}
                                {evt.ownerLastName}, {evt.ownerFirstName}
                              </b>
                              <br />
                              {evt.description}
                            </StripedTableCell>
                          </StripedTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Paper>
                  <Stack direction="column" spacing={1} sx={{ mt: 0 }}>
                    <Button
                      key="signup"
                      onClick={handleEvents}
                      size="large"
                      color="success"
                      variant="contained"
                    >
                      EVENTS
                    </Button>
                  </Stack>
                </AccordionDetails>
              </Accordion>
            )}

            {isCourseEnabled(_school) && (
              <Accordion
                defaultExpanded={_tabsToShow[0] === "coursesTab"}
                disableGutters
                sx={{ mt: 1 }}
              >
                <AccordionSummary
                  className="accordionTitle"
                  expandIcon={<ExpandMoreIcon />}
                >
                  Courses
                </AccordionSummary>
                <AccordionDetails>
                  <SubTitle text={"Today's Courses:"} />
                  <Stack direction="column" spacing={1}>
                    <Button
                      variant="contained"
                      key="signup"
                      onClick={handleCourses}
                      sx={{ mb: 1 }}
                      size="large"
                    >
                      View Courses
                    </Button>
                  </Stack>

                  <StudentCourseGrid
                    signupDate={dayjs().format("YYYY-MM-DD")}
                    sourceUrl="/student/welcome"
                  />
                </AccordionDetails>
              </Accordion>
            )}
          </>
        )}
      </Container>

      <Dialog
        fullWidth={true}
        open={_tomorrowDialogOpen}
        onClose={handleTomorrowDialogClose}
      >
        <DialogTitle sx={{ p: 1 }}>Tomorrow</DialogTitle>
        <DialogContent sx={{ pb: 0 }}>
          <Paper elevation={3} sx={{ mt: 1, mb: 1 }}>
            <List sx={{ width: "100%" }}>
              {_tomorrowPeriods.map((period, index) => (
                <PeriodListItem
                  key={index}
                  school={_school}
                  periodNumber={index + 1}
                  period={period}
                />
              ))}
            </List>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleTomorrowDialogClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default StudentWelcome;
